import Icon from '@app/lui2/Icon';
import Spinner from '@app/lui2/Spinner';
import {colorVar, getOnColor} from '@app/lui2/Theme/colors';
import styled from 'styled-components';

import AbsLayer from './AbsLayer';

interface Props {
  state?: 'loading' | 'loaded' | 'error';
}

const COLOR = {
  loading: 'primary',
  loaded: 'success',
  error: 'error',
} as const;

const ICON = {
  loading: <Spinner />,
  loaded: <Icon icon="done" />,
  error: <Icon icon="error" />,
} as const;

const LoadingBaseLayer = styled(AbsLayer)<Required<Props>>`
  background-color: ${({state}) =>
    state !== 'loading' && colorVar(COLOR[state])};
`;

const IconLayer = styled(AbsLayer)<Required<Props>>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({state}) =>
    state !== 'loading' && colorVar(getOnColor(COLOR[state]))};
`;

const LoadingStateLayer = ({state}: Props) => {
  if (state) {
    return (
      <>
        <LoadingBaseLayer state={state} />
        <IconLayer state={state}>{ICON[state]}</IconLayer>
      </>
    );
  }
  return null;
};

export default LoadingStateLayer;
